import React, { ComponentType } from 'react';
import styled from '@emotion/styled';
import { ITheme, Paper } from '../../../../../../ui';
import { StyledBookingSummarySection } from './BookingSummarySection';
import { ParkingProductSummary } from './ParkingProductSummary';
import { BookingSummaryFooter } from './BookingSummaryFooter';
import { AncillariesSummary } from './AncillariesSummary';
import { BookingSummaryHeader } from './BookingSummaryHeader';
import { getTotalNewBookingPrice } from '../../../../domain/booking/models/helpers/getTotalNewBookingPrice';
import { getOriginalGrandTotalPrice } from '../../../../domain/booking/models/helpers/getOriginalGrandTotalPrice';
import { IBooking } from '../../../../domain/booking/models/IBooking';
import { INewBooking } from '../../../../domain/booking/models/INewBooking';
import { BookingSummaryPromotions } from './BookingSummaryPromotions';
import { IBookingSummarySubmitProps } from './IBookingSummarySubmitProps';

export const StyledBookingSummary = styled(Paper)<{}, ITheme>`
	p {
		max-width: 100px;
	}

	${StyledBookingSummarySection} + hr {
		margin-top: 24px;
	}
`;

interface IBookingSummaryProps {
	booking: INewBooking;
	originalBooking?: IBooking;
	Submit?: ComponentType<IBookingSummarySubmitProps>;
	changeButtonUrl?: string;
}

export const BookingSummary = ({
	booking,
	originalBooking,
	Submit,
	changeButtonUrl,
}: IBookingSummaryProps) => {
	const originalTotalPrice =
		originalBooking && getOriginalGrandTotalPrice(originalBooking);
	const totalPrice = getTotalNewBookingPrice(booking);
	const discount = booking.parkingProduct?.price.discount;
	const earningLoyaltyPoints = booking.parkingProduct?.loyaltyPoints;

	return (
		<StyledBookingSummary>
			<BookingSummaryHeader />

			<ParkingProductSummary
				booking={booking}
				changeButtonUrl={changeButtonUrl}
			>
				<AncillariesSummary ancillaries={booking.ancillaries} />

				{booking.promoCode && !!discount && Boolean(+discount) && (
					<BookingSummaryPromotions
						promoCode={booking.promoCode}
						discount={discount}
					/>
				)}
			</ParkingProductSummary>

			<BookingSummaryFooter
				originalTotalPrice={originalTotalPrice}
				totalPrice={totalPrice}
				loyaltyPoints={earningLoyaltyPoints}
				Submit={Submit}
			/>
		</StyledBookingSummary>
	);
};
